import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useAuth } from '../lib/AuthContext';
import { ShieldAlert, LogOut } from 'lucide-react';

const Layout = () => {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="w-12 h-12 border-4 border-primary-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== 'SYSTEM_ADMIN') {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6 text-center">
        <div className="p-4 bg-red-100 text-red-600 rounded-full mb-6">
          <ShieldAlert size={48} />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Access Denied</h1>
        <p className="text-gray-600 max-w-md mb-8">
          Your account (<strong>{user.email}</strong>) does not have System Admin privileges.
        </p>
        <button
          onClick={async () => { await logout(); }}
          className="flex items-center gap-2 bg-gray-900 text-white px-6 py-3 rounded-xl hover:bg-gray-700 transition-colors"
        >
          <LogOut size={18} />
          Sign out and switch account
        </button>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      {/* pt-14 on mobile to clear the fixed top bar; lg:ml-64 for the fixed sidebar */}
      <main className="flex-1 lg:ml-64 p-6 sm:p-8 lg:p-10 transition-all duration-300 min-w-0">
        <div className="max-w-7xl mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
